import * as t from 'io-ts'
import fetchApi from '../fetch-api'

type PropsT ={
	prompt: string
	sessionId: string
}


const chatResponseCodec = t.type({
        companyID: t.string,
        sessionId: t.string,
        response: t.string
})

export const agentXMutation = (props: PropsT) => {
  return fetchApi({
    service: "core-service",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    pathname: `/ai-chat`,
    codec:chatResponseCodec,
    body: props,
  });
};